import { gql } from '@lojinha/palantir'

export const KIT_QUERY = gql`
  query GetKit($slug: String!, $distributionCenterId: String) {
    kitBySlug(slug: $slug) {
      id
      name
      kind
      classification
      sku
      price
      priceFrom
      description
      imageUrl
      sellingStatus
      isAvailable(distributionCenterId: $distributionCenterId)
      seo {
        url
      }
      firstOfferReplacement {
        firstBuy {
          id
          sku
          name
          price
          priceFrom
          totalMealsCount
          imageUrl
        }
        rebuy {
          id
          sku
          name
          price
          priceFrom
          totalMealsCount
          imageUrl
        }
      }
      itemTags(maxTags: 4) {
        totalCount
        nodes {
          colorPalette
          content
        }
      }
      pricePerDay
      totalMealsCount
      days {
        dayNumber
        periods {
          name
          products {
            id
            name
            price
            priceFrom
            imageUrl
            sku
            seo {
              url
            }
          }
          totalWeight
          totalPrice
          totalKcal
        }
        totalKcal
      }
    }
  }
`
